module.exports = __webpack_public_path__ + "static/media/bigBlue.7169b1ba.JPG";